'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _utils = require('../../utils');

var _DocumentTableBody = require('./DocumentTableBody');

var _DocumentTableBody2 = _interopRequireDefault(_DocumentTableBody);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DocumentTable = (_dec = (0, _mobxReact.inject)('SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(DocumentTable, _Component);

  function DocumentTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DocumentTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DocumentTable.__proto__ || Object.getPrototypeOf(DocumentTable)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isDropActive', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DocumentTable, [{
    key: 'onDrop',
    value: function onDrop(files) {
      if (files.length) {
        this.props.onDrop(files);
      }
      this.isDropActive.setFalse();
    }
  }, {
    key: 'onDownloadAllClick',
    value: function onDownloadAllClick(event) {
      var _props = this.props,
          SessionStore = _props.SessionStore,
          downloadAllUrl = _props.downloadAllUrl;

      window.open(SessionStore.addAuthenticationToUrl(downloadAllUrl), '_self');
    }
  }, {
    key: 'onBrowseClick',
    value: function onBrowseClick() {
      var onClickAddNew = this.props.onClickAddNew;

      if (onClickAddNew) {
        onClickAddNew();
        return;
      }

      !!this.refDropzone && this.refDropzone.open();
    }
  }, {
    key: 'setRefDropzone',
    value: function setRefDropzone(ref) {
      this.refDropzone = ref;
    }
  }, {
    key: 'renderDownloadAll',
    value: function renderDownloadAll() {
      if (!this.hasDocuments || !this.props.downloadAllUrl) {
        return;
      }

      return _react2.default.createElement(
        _Button2.default,
        { className: 'btn-download-all', bsStyle: 'link', onClick: this.onDownloadAllClick },
        _react2.default.createElement(_Icon2.default, { type: 'download' }),
        'Download all'
      );
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay() {
      var isUploading = this.props.isUploading,
          className = (0, _classnames2.default)('dropzone-area', 'dropzone-overlay', { disabled: isUploading }, { uploading: isUploading });


      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(_Icon2.default, { className: 'main-icon', type: 'files-o' }),
        !isUploading ? 'Drop files here' : 'Uploading...'
      );
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var _props2 = this.props,
          renderActions = _props2.renderActions,
          title = _props2.title;


      if (!title) {
        return;
      }

      return _react2.default.createElement(
        'h3',
        null,
        title,
        _react2.default.createElement(
          'div',
          { className: 'title-actions' },
          this.renderDownloadAll(),
          renderActions()
        )
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _props3 = this.props,
          columns = _props3.columns,
          documents = _props3.documents,
          selectable = _props3.selectable,
          title = _props3.title,
          hasHeader = _props3.hasHeader,
          onCheck = _props3.onCheck;


      if (!this.hasDocuments) {
        return;
      }

      return _react2.default.createElement(_DocumentTableBody2.default, {
        columns: columns,
        documents: documents,
        hasHeader: hasHeader,
        onCheck: onCheck,
        selectable: selectable,
        title: title
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          accept = _props4.accept,
          documents = _props4.documents,
          dropzoneText = _props4.dropzoneText,
          emptyDropLarge = _props4.emptyDropLarge,
          isUploading = _props4.isUploading,
          onDrop = _props4.onDrop,
          onDropRejected = _props4.onDropRejected,
          selectable = _props4.selectable,
          canDrop = !!onDrop,
          tableClassNames = (0, _classnames2.default)('document-table', { 'empty-drop-large': emptyDropLarge }, { empty: !documents.length }, { selectable: selectable }),
          dropClassNames = (0, _classnames2.default)('dropzone', 'small', { active: this.isDropActive.isTrue || isUploading });


      return _react2.default.createElement(
        'div',
        { className: tableClassNames },
        this.renderTitle(),
        canDrop ? _react2.default.createElement(
          _reactDropzone2.default,
          {
            accept: accept,
            className: dropClassNames,
            disabled: isUploading,
            disableClick: true,
            onDragEnter: this.isDropActive.setTrue,
            onDragLeave: this.isDropActive.setFalse,
            onDrop: this.onDrop,
            onDropRejected: onDropRejected,
            ref: this.setRefDropzone,
            style: {}
          },
          this.renderOverlay(),
          this.renderTable(),
          _react2.default.createElement(
            'div',
            { className: 'dropzone-area' },
            _react2.default.createElement(_Icon2.default, { className: 'main-icon', type: 'files-o' }),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { className: 'btn-browse', onClick: this.onBrowseClick },
                _react2.default.createElement(_Icon2.default, { type: 'plus-square-o' }),
                ' Upload'
              ),
              ' or (',
              dropzoneText,
              ')'
            )
          )
        ) : this.renderTable()
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'hasDocuments',
    get: function get() {
      var documents = this.props.documents;

      return documents && !!documents.length;
    }
  }]);

  return DocumentTable;
}(_react.Component), _class3.defaultProps = {
  dropzoneText: 'Drag & drop your documents',
  hasHeader: false,
  onDropRejected: _noop3.default,
  renderActions: _noop3.default,
  selectable: false
}, _class3.propTypes = {
  accept: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  columns: _propTypes2.default.array.isRequired,
  documents: _propTypes2.default.array,
  downloadAllUrl: _propTypes2.default.string,
  dropzoneText: _propTypes2.default.string,
  emptyDropLarge: _propTypes2.default.bool,
  hasHeader: _propTypes2.default.bool,
  isUploading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  onClickAddNew: _propTypes2.default.func,
  onDrop: _propTypes2.default.func,
  onDropRejected: _propTypes2.default.func,
  renderActions: _propTypes2.default.func,
  selectable: _propTypes2.default.bool,
  SessionStore: _propTypes2.default.object.isRequired,
  title: _propTypes2.default.string
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isDropActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool(false);
  }
})), _class2)) || _class) || _class) || _class);
var _default = DocumentTable;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DocumentTable, 'DocumentTable', '/app/src/components/common/DocumentTable.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common/DocumentTable.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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